import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';

export const isMobilePlatform = ref(false);

const resizeEventHandler = () => {
  if (window.screen.width >= 992) {
    isMobilePlatform.value = false;
  } else {
    isMobilePlatform.value = true;
  }
};

window.addEventListener('resize', resizeEventHandler);

// parse path and get page category
/*
  ex:
  /operator/dashboard => operator
  /family/dashboard => family
  /partner/dashboard => partner
*/
const getPageCategory = (path?: string | null) => {
  let pageCategory = '';
  if (!path) {
    return pageCategory;
  } else if (path.substring(1, 9) === 'operator') {
    pageCategory = 'operator';
  } else if (path.substring(1, 7) === 'family') {
    pageCategory = 'family';
  } else if (path.substring(1, 8) === 'partner') {
    pageCategory = 'partner';
  } else if (path.substring(1, 10) === 'affiliate') {
    pageCategory = 'affiliate';
  }

  return pageCategory;
};

export const useApp = () => {
  return { isMobilePlatform };
};

export const useDashboard = () => {
  const route = useRoute();

  resizeEventHandler();

  const dashboardCategory = computed(() => getPageCategory(route?.path));
  const isOperatorDashboard = computed(() => dashboardCategory.value === 'operator');
  const isFamilyDashboard = computed(() => dashboardCategory.value === 'family');
  const isPartnerDashboard = computed(() => dashboardCategory.value === 'partner');
  const isAffiliateDashboard = computed(() => dashboardCategory.value === 'affiliate');

  return {
    dashboardCategory,
    isOperatorDashboard,
    isFamilyDashboard,
    isPartnerDashboard,
    isAffiliateDashboard,
  };
};
